import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  private activeRequests = 0;

  constructor() { }

  show() {
    this.activeRequests++;
    setTimeout(() => this.isLoadingSubject.next(this.activeRequests > 0));
  }

  hide() {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    setTimeout(() => this.isLoadingSubject.next(this.activeRequests > 0));
  }
}
